import { Injectable } from '@angular/core'
import type { ListPageProperties, SegmentTagV2 } from '../shared/analytics/models/segment-tag.model'
import { SegmentService } from '../shared/analytics/services/segment.service'
import { DEFAULT_OG_IMAGE_HEIGHT, DEFAULT_OG_IMAGE_WIDTH, PageMetaService } from '../libs/page-meta/page-meta.service'
import { take } from 'rxjs'
import { VerticalService } from '../singleton-services/vertical.service'

/**
 * The standard Page tag for the schedule (/events) page view.
 *
 * @remarks
 * This is expected to be used with pageV2, as indicated by the use of the
 * SegmentTagV2 interface and `autoPageCall: false`.
 *
 * @see SegmentService#pageV2
 * @see SegmentTagV2
 */
export const SCHEDULE_TAG: SegmentTagV2 = {
  page_category: 'Schedule',
  category: 'Events',
  autoPageCall: false
}

@Injectable()
export class ScheduleAnalyticsService {
  public constructor(
    private readonly segment: SegmentService,
    private readonly pageMeta: PageMetaService,
    private readonly verticalService: VerticalService
  ) {}

  public sendPageCall(pageProperties: ListPageProperties = { _tag: 'list' }): void {
    this.segment.pageV2(SCHEDULE_TAG, pageProperties)
  }

  public setPageMeta(): void {
    this.verticalService.siteSettings$.pipe(take(1)).subscribe(settings => {
      this.pageMeta.setPageMeta({
        title: `Schedule - ${settings.site_name}`,
        type: 'website',
        description: settings.meta_events_schedule_page_description ?? '',
        twitterCard: 'summary_large_image',
        canonicalUrl: settings.core_site_url ? `${settings.core_site_url}/events` : '',
        image: {
          url: settings.meta_default_image ?? '',
          width: DEFAULT_OG_IMAGE_WIDTH,
          height: DEFAULT_OG_IMAGE_HEIGHT
        },
        siteName: settings.site_name
      })
    })
  }
}
